import React from 'react';
import { Paper, Typography, Grid, TextField, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, Button } from '@mui/material';

interface Props {
    showOtherProductForm: boolean;
    otherProductName: string;
    setOtherProductName: (v: string) => void;
    otherProductType: any;
    setOtherProductType: (v: any) => void;
    isProcessed: boolean;
    setIsProcessed: (v: boolean) => void;
    productionTypes: any[];
    handleAddOtherProduct: () => void;
}

export const OtherProductForm: React.FC<Props> = ({
    showOtherProductForm,
    otherProductName,
    setOtherProductName,
    otherProductType,
    setOtherProductType,
    isProcessed,
    setIsProcessed,
    productionTypes,
    handleAddOtherProduct,
}) => {
    if (!showOtherProductForm) return null;

    return (
        <Paper elevation={1} sx={{ mt: 3, p: 3 }}>
            <Typography variant="subtitle1" gutterBottom>
                Adicionar Outro Produto
            </Typography>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        label="Nome do Produto *"
                        value={otherProductName}
                        onChange={(e) => setOtherProductName(e.target.value)}
                        error={!otherProductName.trim() && showOtherProductForm}
                        helperText={!otherProductName.trim() && showOtherProductForm ? 'Campo obrigatório' : ''}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <FormControl fullWidth error={!otherProductType && showOtherProductForm}>
                        <InputLabel size="small">Tipo de Produção *</InputLabel>
                        <Select
                            size="small"
                            value={otherProductType}
                            onChange={(e) => setOtherProductType(e.target.value as any)}
                            label="Tipo de Produção *"
                        >
                            {productionTypes.map((value) => (
                                <MenuItem key={value} value={value}>
                                    {value}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={2}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={isProcessed}
                                onChange={(e) => setIsProcessed(e.target.checked)}
                            />
                        }
                        label="Processado"
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddOtherProduct}
                        disabled={otherProductName.trim() === '' || otherProductType === ''}
                        fullWidth
                        size="small"
                        data-testid="add-other-product"
                    >
                        + Adicionar
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default OtherProductForm;
